import React from 'react';
import { useDispatch } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { Close } from '@mui/icons-material';
import Button from '../CustomButtons/Button.js';
import { createUseStyles } from 'react-jss';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog.js';

const styles = {
    actionButton: {
        padding: '5px 2px 5px 5px',
        marginLeft: '5px',
    },
};

const useStyles = createUseStyles(styles);

const DIALOG_CLOSED = { open: false };

const DeleteButton = ({ t, action, setLimit, msg = '', disabledbtn = false, style, onClick }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [dialog, setDialog] = React.useState(DIALOG_CLOSED);

    const handleConfirm = () => {
        if (onClick) {
            onClick();
        } else {
            dispatch(action);
            if (setLimit) setLimit();
        }
        setDialog(DIALOG_CLOSED);
    };

    return (
        <React.Fragment>
            <ConfirmDialog
                open={dialog.open}
                title={t('are_you_sure')}
                type="danger"
                onConfirm={handleConfirm}
                onCancel={() => setDialog(DIALOG_CLOSED)}
                confirmText={t('delete_yes')}
                cancelText={t('cancel')}
            />
            <Button
                color="danger"
                className={classes.actionButton}
                onClick={() => onClick ? onClick() : setDialog({ open: true })}
                disabled={disabledbtn}
                style={{ ...style }}
                title={t('delete')}
            >
                {msg === '' ? (
                    <Close className={classes.icon} />
                ) : (
                    <span style={{ padding: '2px 7px' }}>{msg}</span>
                )}
            </Button>
        </React.Fragment>
    );
};

export default withTranslation('', { withRef: true })(DeleteButton);
